import { FC, useState } from 'react';
import clsx from 'clsx';
import { dateToMonthYear, maskedCardNumber } from 'lib/utils';
import { ICard, IAccount } from 'lib/type';
import Card from '../presentational/Card';
import { cardImages, cardPos } from 'constants/shared/enums';
import { accountRoles } from 'lib/constants';
import PlaceholderVerticalCard from 'lib/_content/images/cards/SM_Placeholder.png';
import { cobrandedCardLookup } from 'lib/constants/cards'

interface CarouselContainerProps {
    cards: ICard[];
    account: IAccount;
    handleCardClick: (position: string, index: number) => void;
    currentCard: ICard
}

const CarouselContainer: FC<CarouselContainerProps> = ({
    cards,
    account,
    handleCardClick,
    currentCard
}) => {
    const [flippedCards, setFlippedCards] = useState<Record<string, boolean>>({});

    const toggleFlip = (cardId: string) => {
        if (currentCard?.cardSerial !== cardId) return;
        setFlippedCards(prev => ({
            ...prev,
            [cardId]: !prev[cardId],
        }));
    };

    return (
        <div className="carousel-container">
            <div className="carousel-wrapper">
                {cards.map((card, index) => {
                    const position = cardPos[index];
                    const image =
                        cobrandedCardLookup[card?.designId] ||
                        cardImages[account.productType] ||
                        PlaceholderVerticalCard;
                   
                    const premiumAccount = account.productType === accountRoles.Premium;

                    const cardId = card?.cardSerial ?? `card-${index}`;
                    return (
                        <div
                            key={cardId}
                            className={`carousel-item ${position}`}
                        >
                            {!!card && (
                                <div
                                    className={clsx('card-content', {
                                        primary: premiumAccount,
                                        'cobranded-content': cobrandedCardLookup[card?.designId],
                                    })}
                                >
                                    <div
                                        className={clsx('flip-card-inner', {
                                            flipped: flippedCards[cardId],
                                        })}
                                    >
                                        <div className="flip-card-front">
                                            <img
                                                onMouseDown={e => {
                                                    e.stopPropagation();
                                                    toggleFlip(cardId);
                                                    handleCardClick(position, index);
                                                }}
                                                className={clsx({
                                                    'cobranded-image': cobrandedCardLookup[card?.designId],
                                                })}
                                                src={image}
                                                alt="suits-me card"
                                            />
                                            <Card
                                                card={card}
                                                account={account}
                                                position={position}
                                            />
                                        </div>
                                        <div
                                            onMouseDown={e => {
                                                e.stopPropagation();
                                                toggleFlip(cardId);
                                                handleCardClick(position, index);
                                            }}
                                            className="flip-card-back"
                                            role='button'
                                        >
                                            <p>{card.cardHolderName}</p>
                                            <p>{maskedCardNumber(card.cardPan)}</p>
                                            <p>{dateToMonthYear(card.expiryDate)}</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CarouselContainer;
